<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import u from "./assets/js/util";

export default {
  name: 'App',
  mounted() {
    u.setCookie("module", "public")
  }
}
</script>

<style>




.cencent {
  overflow: hidden;
  position: absolute;
  width: calc(100%);
  height: calc(100%);
  box-sizing: content-box;

}

.top {
  height: 40px;
  text-align: right;
  line-height: 40px;
  padding-left: 20px;
  padding-right: 20px;
}

.bottom {
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: space-between;

}

.pointer {
  cursor: pointer;
}

.status_active {
  margin-left: 15px;
  cursor: pointer;
  color: #2271d8;
  font-size: 14px;
}

.cencent_blac {
  background-color: #FFFFFF;
}

.title {
  display: flex;
  background-color: #FFFFFF;
  padding: 10px;
  width: calc(100% - 40px);
  border-radius: 2px;
}

.subject {
  width: 100%;
  background-color: #FFFFFF;
  height: calc(100% - 70px);
  width: calc(100% - 20px);
  border-radius: 2px;
}

.cursor {
  cursor: pointer;

}

.cursor:hover {
  color: #2271d8;
}

.active {
  color: #2271d8;
  font-weight: 600;
}

.btn-txt {
  color: #267EF0;
  cursor: pointer;
}

.btn-error {
  color: #FF3C32;
  cursor: pointer;
}

.btn-success {
  color:#2E6CFF;
  cursor: pointer;
  user-select: none;
}

/deep/ .el-dialog__header {
  padding: 10px;
}

/deep/ .el-dialog__body {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue